import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import salaryCuts from "../../../containers/modules/hr/salary-cuts";

export default function SalaryCutsRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="salary-cuts"
      index
      element={
        <AccessControl
          name={"Salary Cuts List"}
          auth={authUser}
          component={salaryCuts}
        />
      }
    ></Route>
  );
}
